import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import utils from 'utils';
import selectors from 'state/selectors';
import actions from 'state/actions';
import styled from 'styled-components/macro';

import Modal from 'components/Modal';
import Datepicker from 'components/Input/datepicker/Datepicker';
import services from 'services';
const DatePickerContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px;
`;

const SetScanDate = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const [scanDate, setScanDate] = useState<Date>();
  const [requiredError, setRequiredError] = useState<boolean>(false);
  const protocolArr = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const userCode = useSelector(selectors.user.getIdUser);
  const dateFormat = useSelector(selectors.user.getUserPreference).dateFormat;
  const [errorProtocols, setErrorProtocols] = useState<number[]>([]);
  const [visibily, setErrorModal] = useState(false);
  const [ErrorModal] = utils.hooks.useBulkActionErrorModal(errorProtocols, visibily);

  const updateDocumentImage = async (protocol: number) => {
    try {
      const { data } = await services.getDocumentImage({ protocol, area: 'modal' });
      dispatch(actions.documents.setDocumentImage(data));
    } catch (e) {
      console.error(e);
    }
  };

  const handleScanDate = async () => {
    if (scanDate) {
      try {
        setRequiredError(false);
        const convertedDate = utils.date.formatDateForDb(scanDate);
        const requestBody = {
          protocol: protocolArr,
          date: convertedDate,
          idUser: userCode,
        };
        const { data } = await services.changeScanData(requestBody);
        let tableData = null;
        const { protocolsList } = data;
        if (!data.success) {
          data.protocolsList.forEach(({ changedSuccessfully, protocolIn, protocol }) => {
            if (changedSuccessfully) {
              tableData = { protocols: [protocol], property: 'protocolIn', value: protocolIn };
              dispatch(actions.documents.updateTableRows(tableData));
            }
          });
          setErrorProtocols(
            protocolsList.filter(({ changedSuccessfully }) => !changedSuccessfully).map(({ protocol }) => protocol),
          );
          setErrorModal(true);
          const protocolsWithoutError = data.protocolsList
            .filter(({ changedSuccessfully }) => changedSuccessfully)
            .map(({ protocol }) => protocol);
          tableData = { protocols: protocolsWithoutError, property: 'dateIn', value: convertedDate };
          dispatch(actions.documents.updateTableRows(tableData));
          utils.app.notify('warning', t('pdf-date-warning'));
        } else {
          if (protocolArr.length === 1) {
            await updateDocumentImage(protocolArr[0]);
          }
          tableData = { protocols: protocolArr, property: 'dateIn', value: convertedDate };
          dispatch(actions.documents.updateTableRows(tableData));
          data.protocolsList.forEach(({ protocolIn, protocol }) => {
            tableData = { protocols: [protocol], property: 'protocolIn', value: protocolIn };
            dispatch(actions.documents.updateTableRows(tableData));
          });
          utils.app.notify('success', t('pdf-date-succefull-changed'));
          dispatch(actions.modal.closeModal());
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      setRequiredError(true);
    }
  };

  return (
    <>
      {visibily ? (
        <ErrorModal />
      ) : (
        <>
          <Modal.Header title={t('select_scan_date')} />
          <Modal.Content>
            <DatePickerContainer>
              <Datepicker
                onChange={(date) => date && setScanDate(date)}
                hasFeedback={requiredError}
                feedbackMessage={t('field_required')}
                dateFormat={dateFormat}
                portal
              />
            </DatePickerContainer>
          </Modal.Content>
          <Modal.Footer confirmText={t('confirm')} confirmAction={handleScanDate} withCloseButton={false} />
        </>
      )}
    </>
  );
};

export default SetScanDate;
